/**
 * created by lei lei on 2020/5/11
 * 普通树组件 系统角色里面的菜单权限
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Tree, Input, Checkbox, Icon, Popconfirm, Empty} from "antd";
import { uuid } from '../../../utils/index'

const { TreeNode } = Tree;
const { Search } = Input;

export default class OrdinaryTrees extends Component {
    static defaultProps = {
        showBindName: false,
        showSearch: false,
        showFoldBtn: false,
        placeholder: '请输入',
        expandedKeys: [],
        addProcess: () => { },
        editProcess: () => { },//编辑流程
        deleteProcess: () => { },//删除流程
    }
    static propTypes = {
        dataSource: PropTypes.array.isRequired, //数据源
        checkedKeys: PropTypes.array,//默认数选中的据源
        title: PropTypes.string.isRequired,//数据源标识独特的id,不可重复
        keyId: PropTypes.string.isRequired,//数据源标识子节点key
        children: PropTypes.string.isRequired,//数据源的名称字段
        showBindName: PropTypes.bool,//是否显示另一个绑定合并名字
        bindNameKey: PropTypes.string,//与上一个属性合并使用要绑定名字的键值
        checkedKeysAll: PropTypes.func.isRequired,//组件返回的数据源
        showSearch: PropTypes.bool,//是否显示输入框搜索功能
        placeholder: PropTypes.string,//与上一个搜索框属性一块使用，自定义提示文字
        showFoldBtn: PropTypes.bool,//是否显示折叠按钮
        expandedKeys: PropTypes.array,//默认展开项,这个是点击流程图之后需要的属性，
        addProcess: PropTypes.func,//增加流程按钮
        editProcess: PropTypes.func,//编辑流程
        deleteProcess: PropTypes.func,//删除流程
    }

    constructor(props) {
        super(props);
        this.state = {
            expandedKeys: [],//展开的节点树
            autoExpandParent: true,
            checkedKeys: [],//选中的数据
            selectedKeys: [],//选中的文字s
            isFirst: true,
            searchText: '',
            searchText2: '',
            foldStatus: false,
            allExpandedKeys: [],
            searchExpandedKeys: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // if(this.state.isFirst){
        this.addNewName(this.props.dataSource)
        //  this.getFoldAllKey(this.props.dataSource)
        this.state.checkedKeys = this.state.checkedKeys.concat(this.props.checkedKeys)
        this.state.isFirst = false
        this.setState({})
        // }
    }

    componentWillReceiveProps(newProps) {
        this.state.checkedKeys = newProps.checkedKeys
        if (newProps.expandedKeys.length > 0) {
            this.state.expandedKeys = newProps.expandedKeys
        }

        this.state.autoExpandParent = true //给树型结构赋值后，该属性为true后才可以展开树结构，
        this.setState({})
    }

    render() {
        this.addNewName(this.props.dataSource)
        return (
            <div>
                {this.props.showSearch ?
                    <Search
                        style={{ marginBottom: 8, width: 250, marginLeft: 10 }}
                        placeholder={this.props.placeholder}
                        onSearch={value => this.onChange('search',value)}
                        onChange={value => this.onChange('change',value)}
                        value={this.state.searchText2}
                        enterButton

                    />
                    : null}
                {
                    this.props.showFoldBtn ?
                        <Checkbox style={{ marginLeft: 10, marginTop: 5 }} checked={this.state.foldStatus}
                            onClick={() => {
                                this.onClickFold()
                            }
                            }>展开</Checkbox> : null
                }
                {this.props.dataSource && this.props.dataSource.length ?
                    <Tree
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        /*  checkStrictly={true}*/
                        onExpand={this.onExpand}
                        expandedKeys={
                           this.state.expandedKeys
                        }
                        selectable={false}
                        autoExpandParent={this.state.autoExpandParent}
                        onCheck={this.onCheck}
                        checkedKeys={this.state.checkedKeys}
                        // onSelect={this.onSelect}
                        selectedKeys={[]}
                    >
                        {this.renderTreeNodes(this.props.dataSource)}
                    </Tree>
                    :<Empty/>}
            </div>

        )
    }

    onExpand = expandedKeys => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        // console.log('expandedKeys',expandedKeys)
        this.props.onExpand && typeof this.props.onExpand == 'function' && this.props.onExpand(expandedKeys)
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

    onCheck = (checkedKeys, info) => {
        let roleMenu = [...checkedKeys, ...info.halfCheckedKeys];//并集包含半选
        this.props.checkedKeysAll && this.props.checkedKeysAll(checkedKeys, roleMenu);//把数据返回到页面里面去
        this.setState({ checkedKeys });

    };

    // 注意：打开这个方法会造成点击节点改变背景色
    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    };

    renderTreeNodes = data =>
        data.map(item => {
            const index = this.state.searchText.length > 0 ? item.newTitle.indexOf(this.state.searchText) : -1;
            const newTitle = <div
                style={{ width: 250, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                title={item.newTitle}
            >
                <span>
                    <span style={{ color: (index > -1) || this.props.correlationKeys.includes(item[this.props.keyId]) ? '#f50' : "" ,display: 'flex'}}>
                        <span style={{ width: 150, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                            }}
                        >{item.newTitle}</span>
                        {
                            item.lock ?
                                null :
                                <>
                                    {
                                        item.sourceUrl ? null : <Icon
                                            type="plus"
                                            style={{ marginLeft: 10, marginRight: 10,alignSelf:'center' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.addProcess(item);
                                            }}
                                        />
                                    }
                                    {item.treeCode=="activitiTreeRoot"?null:<span>
                                            <Icon
                                                type="form"
                                                style={{ marginLeft: 10, marginRight: 10,alignSelf:'center' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.editProcess(item)
                                                }}
                                            />
                                        </span>}
                                    <Popconfirm
                                        
                                        title={<div>确定删除节点：{item.name.length>30 ? item.name.substr(0,30)+"..." +item.name.substr(-5):item.name}</div>}
                                        onConfirm={(e) => {
                                            e.stopPropagation();
                                            this.deleteProcess(item)
                                        }}
                                        
                                        onCancel={(e) => {
                                            e.stopPropagation();
                                        }}
                                        okText="确认"
                                        cancelText="取消"
                                        onClick={(e)=>{
                                            e.stopPropagation();
                                        }}
                                    >
                                        {item.treeCode=="activitiTreeRoot"?null:<span>
                                            <Icon
                                                type="close"
                                                style={{ marginLeft: 10, marginRight: 10 }}
                                            />
                                        </span>}
                                    </Popconfirm>
                                </>
                        }
                    </span>
                </span>
            </div>


            if (item[this.props.children]) {
                return (
                    <TreeNode title={newTitle} key={item[this.props.keyId]} dataRef={item}>
                        {this.renderTreeNodes(item[this.props.children])}
                    </TreeNode>
                );
            }
            return <TreeNode key={item[this.props.keyId]} {...item} />;
        });

    //给树关联的数据增加新的名字需要真实树的名字和关联的流程的名字 以及折叠功能的所有展开点的数据集合
    addNewName(data) {
        let keyId = this.props.keyId
        let childKey = this.props.children
        if (data && data.length > 0) {
            data.forEach((item) => {
                if (this.props.showBindName) {
                    if (this.props.bindNameKey) {
                        item.newTitle = item[this.props.title]
                        let tempName = "";
                        if (this.props.bindNameKey.indexOf(".") > 0) {
                            var keyTemp = this.props.bindNameKey.split(".");
                            var itemCopy = JSON.parse(JSON.stringify(item));
                            for (let i = 0; i < keyTemp.length; i++) {
                                itemCopy = itemCopy[keyTemp[i]];
                                if (!itemCopy)
                                    break;
                                if (i == (keyTemp.length - 1)) {
                                    tempName = itemCopy;
                                }
                            }
                        }
                        if (tempName) {
                            item.newTitle += '——(' + tempName + ')'
                        }
                    } else {
                        item.newTitle = item[this.props.title]
                    }
                } else {
                    item.newTitle = item[this.props.title]
                }
                //获取所有的树节点开始
                if (item[childKey] && item[childKey].length > 0) {
                    this.state.allExpandedKeys.push(item[keyId])
                }
                if (!item[childKey] || item[childKey].length < 1) {
                    item[childKey] = []
                }
                //获取所有的树节点结束
                this.addNewName(item[childKey])

            })
        }
    }

    //搜索框输入变化的时候调用为提高性能，去掉了输入内容变化后调用改为点击搜索或者enter调用
    onChange(type,textValue,call) {
        if(type=='change') return this.setState({searchText2:textValue.target.value});
        if (textValue.length < 1) {
            this.state.expandedKeys = []
        }else {
            this.props.onSearchCall(); // 点击搜索的回调
        }
        {
            this.state.searchExpandedKeys = [];
            this.getSearchOpenKey(this.props.dataSource, textValue)
        }
        this.state.autoExpandParent = true;
        this.state.foldStatus=false; // 点击搜索后将展开框取消
        this.setState({ searchText2: textValue,searchText: textValue, expandedKeys: this.state.searchExpandedKeys },()=>{
            call&&call()
        })
    }

    //点击折叠
    onClickFold() {
        if (!this.state.foldStatus) {
            this.state.expandedKeys = this.state.allExpandedKeys //数据在addNewName里面直接递归增加出来了
            this.state.autoExpandParent = true; // 解决折叠打开后无法关闭子节点
        } else {
            this.state.expandedKeys = []
            this.state.autoExpandParent = false; // 解决折叠打开后无法关闭子节点
        }
        this.setState({ foldStatus: !this.state.foldStatus })
    }

    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        let keyId = this.props.keyId
        let childKey = this.props.children
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.newTitle.indexOf(searchText) : -1;
                if (index > -1) {
                    //if(item[childKey]&&item[childKey].length>0){
                    this.state.searchExpandedKeys.push(item[keyId])
                    /* let keyIdArry=item[keyId].split('-')
                     keyIdArry.forEach((i)=>{
                        this.state.searchExpandedKeys.push(i)
                     })*/
                    // }
                }
                this.getSearchOpenKey(item[childKey], searchText)

            })
        }
    }
    addProcess(item) {
        this.props.addProcess && this.props.addProcess(item);
    }
    editProcess(item) {
        this.props.editProcess && this.props.editProcess(item);
    }
    deleteProcess(item) {
        this.props.deleteProcess && this.props.deleteProcess(item);
    }


}